module.exports = __webpack_public_path__ + "assets/mocro-batterie-2ce835f5cf36a2c5619bdc775a1347be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/mocro-batterie.jpg
// module id = 518
// module chunks = 1